import React from 'react';
import { Empty, Spin } from "antd";
import {useQuery} from "react-query";
import {GetProfile} from "../../../api/profile";
import Moment from 'moment';
import 'moment/locale/ru';

export const Notifications = (props) => {
    const data = useQuery('profile', GetProfile);

    if (data?.data?.profile) {
        if (data?.data?.profile.is_approved === false) {
            return (
                <div className={`appc notification`}>
                    <h1>Уведомления</h1>
                    <div className="appc__wrp">
                        <div className={`notification--item`}>
                            <div className={`notification__date`}>
                                {Moment(data?.data?.profile?.createdAt).fromNow()}
                            </div>
                            <div className={`notification__text`}>
                                Необходимо подтвердить ваш email
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }

    return (
        <Spin spinning={data.isLoading}>
            <div className={`appc notification`}>
                <h1>Уведомления</h1>
                {data.isSuccess && (
                    <div className="appc__wrp">
                        <Empty
                            description={<span>У вас пока нет уведомлений</span>}
                        />
                    </div>
                )}
            </div>
        </Spin>
    );
}

export default Notifications;